import React, { useState, useEffect } from 'react';

function Reportcontent2({ onNext, onBack }) {
  const [abuseTypes, setAbuseTypes] = useState([]);
  const [selectedAbuse, setSelectedAbuse] = useState('');
  const [error, setError] = useState('');


  const handleRadioChange = (event) => {
    setSelectedAbuse(event.target.value);
  };
  const handleNext = () => {
    if (!selectedAbuse) {
      setError('Please select an abuse type before proceeding.');
    } else {
      setError('');
      onNext({
        data: {
          selectedAbuse
        }
      });
    }
  };
  const abuseslist = [
    {
      id: 0,
      title: 'Doping'
    },
    {
      id: 1,
      title: 'Match/ Even Fixing'
    },
    {
      id: 2,
      title: 'Integrity'
    },
    {
      id: 3,
      title: 'Transgressive behavior'
    },
    {
      id: 4,
      title: 'Other'
    },
  ]
  return (
    <div className='r-content'>
      <h4 className='content-title'> The BESAFE Line is intended for submitting reports or questions in relation with:</h4>
      <p className='content-text'>
     Suspicious conduct, related to fixing an event, part of the event or match result
violations of anti-doping regulations
Violations of internal rules and codes of the EYOF Bakuriani 2025, including financial irregularities and illegal or unethical practices
concerns regarding transgressive behaviour  ensuring relevant supervision and prevention
 
EYOF Bakuriani 2025 Safeguarding Officer in close collaborations with IGNITX company will process reports and questions according to the predefined procedure and within the limits of its authority.  All reports and questions relating to violations of anti-doping regulations, will be processed by Georgian Anti Doping Agency (GADA) 
      </p>
      <br />
      <div className="content-text">Type of violation reported :</div>
      <div className="abuselist">
        {/* {abuseTypes.map((abuse) => (
          <div key={abuse.id}>
            <input
              type="radio"
              id={`abuse-${abuse.id}`}
              name="abuseType"
              value={abuse.label}
              checked={selectedAbuse === abuse.label}
              onChange={handleRadioChange}
            />
            <label htmlFor={`abuse-${abuse.id}`}>{abuse.label}</label>
          </div>
        ))} */}
      </div>
      {error && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
      <div className="abusetestlist">
        {
          abuseslist.map((abusedata) => (
          <label className='reportradiobutton' key={abusedata.id}>
              <p className="checkbox-label" htmlFor={`abuse-${abusedata.id}`}>{abusedata.title}</p>
              <input className='custom-radio'
                type="radio"
                id={`abuse-${abusedata.id}`}
                name="abuseType"
                value={abusedata.title}
                checked={selectedAbuse === abusedata.title}
                onChange={handleRadioChange}
              />
          </label>
          ))
        }
      </div>

      <div className='back-next'>
        <button className='Backbtn' onClick={onBack}>Back</button>
        <button className='Nextbtn' onClick={handleNext}>Next</button>
      </div>
    </div>
  );
}

export default Reportcontent2;
